/**
 * 微信sdk分享功能
 */
import wx from 'weixin-js-sdk'
import { getWxUserApi } from '../api'
import { hostUrl } from '../config'
import { getPlatform } from './index'

const platform = getPlatform()

const getWxUser = function () {
    // let wxShareUrl = encodeURIComponent(top.location.href.split('#')[0])
    const urlObj = new URL(window.location.href);
    const shareUrl = `${urlObj.origin}${urlObj.pathname}`
    return new Promise((resolve, reject) => {
        getWxUserApi(shareUrl, { isSigned: true }).then((res) => {
            if (res.code == 200 && res.data) {
                resolve(res.data)
            } else {
                reject(new Error('weixin get config error!'))
            }
        })
    })
}

const wxConfig = function (res, data) {
    wx.config({
        debug: false,
        appId: res.appId,
        timestamp: res.timestamp,
        nonceStr: res.nonceStr,
        signature: res.signature,
        jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'getLocation',
        ]
    })
    wx.ready(function () {
        const shareInfo = {
            title: data.title,
            imgUrl: data.imgUrl,
            link: data.link,
            desc: data.desc
        }
        wx.onMenuShareTimeline(shareInfo)
        wx.onMenuShareAppMessage(shareInfo)
    })
}
const defaultInfo = {
    title: "成为VIP，全年优惠享不停！",
    desc: "1919会员尊享，用不完的特权，享不尽的权益，即刻开启VIP。",
    imgUrl: "https://1919-crm-pro-oss.1919.cn/web_static/vip_share.jpg",
    link: `${hostUrl}`
}

export default function (data) {
    if (!data) {
        data = defaultInfo
    }
    if (platform === 'WX' || platform == 'WX_MINI_APP') {
        getWxUser().then(resData => {
            if (resData) {
                wxConfig(resData, data)
            }
        })
    }
}

// 分享
export const toShare = (data) => {
    const defaultData = {
      shareTitle: '邀请你领吃喝优惠券',
      shareUrl: trimLargeParams(window.location.href),
      shareIcon: 'https://1919-crm-pro-oss.1919.cn/upload/2022/1665638695492-yheoddum.jpeg', //750*600
      shareDescription: '好友邀请你一起领吃喝优惠券，快来参加',
    }
  
    data = { ...defaultData, ...data }
  
    console.log('toShare data', data)
  
    return new Promise((resolve, reject) => {
      if (isApp()) {
        let navData = {
          titleColor: "#333333",
          topTitleBgColor: "#ffffff",
          shareTitle: data.shareTitle,
          shareDescription: data.shareDescription,
          shareIcon: data.shareIcon,
          shareUrl: data.shareUrl,
        };
  
        // 有wxId，可以且只能分享到小程序 (<=7.8.3不支持,需要兼容!)
        if (data.wxId) {
          navData.wxId = data.wxId
        }
  
        console.log('app configNavigationBar:', JSON.stringify(navData))
  
        jsBridge.callHandler("configNavigationBar", JSON.stringify(navData));
  
      } else if (isNewChiheApplet()) {
        const shareCustom = {
          shareUrl: data.shareUrl,
          title: data.shareTitle,
          imageUrl: data.shareIcon,
        }
  
        console.log('postMessage shareCustom:', shareCustom)
  
        wx.miniProgram.postMessage({
          data: {
            shareCustom,
          },
        });
      }
    })
  }
  